import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AdminLookupsResult, SignupOrPaMspLookupsResult } from '../interfaces/lookups-result.interface';
import { HttpClient } from '@angular/common/http';
import { LookupResponse } from '../interfaces/lookup-response.interface';

@Injectable({
  providedIn: 'root',
})
export class LookupsApiService {
  http = inject(HttpClient);

  public getSignUpOrPaMspLookups$(): Observable<LookupResponse<SignupOrPaMspLookupsResult>> {
    return this.http.get<LookupResponse<SignupOrPaMspLookupsResult>>(`/lookups/senderid/signup`);
  }

  public getAdminLookups$(): Observable<LookupResponse<AdminLookupsResult>> {
    return this.http.get<LookupResponse<AdminLookupsResult>>(`/lookups/senderid/organisation-details`);
  }
}
